import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { LegalLinks, LegalModals, useLegalModals } from './LegalModals';
export function FooterCTA() {
  const {
    activeModal,
    setActiveModal
  } = useLegalModals();
  return <footer className="bg-gradient-to-b from-olive to-[#5A6854] text-white py-20 relative overflow-hidden" data-id="element-58">
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '32px 32px'
    }} data-id="element-59"></div>

      <div className="container mx-auto px-6 max-w-4xl text-center relative z-10" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-61">
          <h2 className="text-3xl md:text-4xl font-heading font-semibold mb-10 leading-tight" data-id="element-62">
            Empieza hoy con un plan simple que puede ayudarte a sentirte mejor.
          </h2>

          <div className="mb-16" data-id="element-63">
            <CTAButton text="Quiero mi ebook ahora" variant="light" href="#oferta" data-id="element-64" />
          </div>

          <div className="w-full h-[1px] bg-white/20 mb-8" data-id="element-65"></div>

          <p className="text-white/60 text-sm mb-4" data-id="element-66">
            © {new Date().getFullYear()} — Todos los derechos reservados
          </p>

          <LegalLinks onPrivacy={() => setActiveModal('privacy')} onTerms={() => setActiveModal('terms')} data-id="element-67" />
        </motion.div>
      </div>

      <LegalModals activeModal={activeModal} onClose={() => setActiveModal(null)} data-id="element-68" />
    </footer>;
}